import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { calculatorHref } from "@/lib/landingLinks";

/**
 * The one way a landing page sends somebody into the calculator.
 *
 * Everything goes through here so the ad parameters are never dropped and the
 * service is always named the same way.
 */
export const CalculatorButton = ({
  service,
  children,
  testId,
  variant = "default",
  className = "",
  withArrow = true,
}) => {
  const { search } = useLocation();

  return (
    <Button
      asChild
      size="lg"
      variant={variant}
      data-testid={testId}
      className={`h-12 min-h-[44px] px-5 text-[15px] font-semibold ${className}`}
    >
      <Link to={calculatorHref(service, search)}>
        {children}
        {withArrow ? <ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" /> : null}
      </Link>
    </Button>
  );
};
